import { ChevronDownSmall, ChevronUpSmall, Public } from '@wix/wix-ui-icons-common/on-stage';
import { IconButton } from '@wix/wix-ui-tpa/cssVars';
import classNames from 'classnames';
import React, { forwardRef } from 'react';
import { useTranslation } from '../../../../sdk/components';
import { Flag } from '../flag';
import { classes } from './flag-button.st.css';
export const FlagButton = /*#__PURE__*/ forwardRef(({ arrowDirection, longCountryCode, onClick, readOnly, ariaLabel, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHaspopup }, ref)=>{
    const { t } = useTranslation();
    return /*#__PURE__*/ React.createElement(IconButton, {
        className: classes.root,
        "data-hook": "country-selector-trigger",
        "aria-label": `${ariaLabel}. ${t('field.phone.country-selector-button.aria-label')}`,
        "aria-expanded": ariaExpanded,
        "aria-haspopup": ariaHaspopup,
        innerRef: ref,
        onClick: onClick,
        icon: /*#__PURE__*/ React.createElement("div", {
            className: classes.flagButton
        }, longCountryCode ? /*#__PURE__*/ React.createElement("div", {
            className: classes.flag
        }, /*#__PURE__*/ React.createElement(Flag, {
            longCountryCode: longCountryCode
        })) : /*#__PURE__*/ React.createElement("div", {
            className: classNames(classes.noFlag, {
                [classes.readOnly]: readOnly
            })
        }, /*#__PURE__*/ React.createElement(Public, null)), /*#__PURE__*/ React.createElement("div", {
            className: classNames(classes.arrow, {
                [classes.readOnly]: readOnly
            })
        }, arrowDirection === 'up' ? /*#__PURE__*/ React.createElement(ChevronUpSmall, null) : /*#__PURE__*/ React.createElement(ChevronDownSmall, null)))
    });
});

//# sourceMappingURL=flag-button.js.map